/*
 * @Author:
 * @Description:
 * @Date: 2024-11-20 19:21:18
 * @LastEditors:
 * @FilePath: /rhcn-merchant-web/src/store/getters.js
 */
const getters = {
  permission: state => state.permission,
  app: state => state.app,
  search: state => state.search,
  currentLan: state => state.app.currentLan,
};

export default getters;
